export default "__VITE_ASSET__BabvE19B__"